import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header.js';
import Footer from './Footer.js';
import styled from 'styled-components';

const Main = styled.main`
  min-height: calc(100vh - var(--footer-height));
  margin-top: var(--header-height);
  
  &.home-page {
    margin-top: 0;
  }
  
  @media (max-width: 768px) {
    margin-top: var(--mobile-header-height);
  }
`;

// Aggressive ScrollToTop component that works even with deep scrolling
const ScrollToTop = () => {
  const { pathname } = useLocation();
  
  useEffect(() => {
    // Delay added to wait until DOM update is complete
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'instant' }); 
    }, 0);
    
    // Additional fallback scroll with timeout
    const timeoutId = setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'instant' });
    }, 100); // Second attempt after 100ms
    
    return () => clearTimeout(timeoutId);
  }, [pathname]);
  
  return null;
};

const Layout = ({ children, transparentHeader = false, isHomePage = false }) => {
  return (
    <>
      <ScrollToTop />
      <Header transparent={transparentHeader} />
      <Main className={isHomePage ? 'home-page' : ''}>
        {children}
      </Main>
      <Footer />
    </>
  );
};

export default Layout;